import { render } from "./QrCodeGenerator.vue?vue&type=template&id=0ec26c50&scoped=true"
import script from "./QrCodeGenerator.vue?vue&type=script&lang=js"
export * from "./QrCodeGenerator.vue?vue&type=script&lang=js"

import "./QrCodeGenerator.vue?vue&type=style&index=0&id=0ec26c50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec26c50"]])

export default __exports__